/**
 * The day an Epicor date names, at local midnight, for display.
 *
 * Epicor dates are days, sent as 2026-09-02T00:00:00-04:00 (OData lists, BAQs), 2026-09-02T00:00:00 (GetByID)
 * or 2026-09-02. `new Date()` reads the first and the last as an instant, which a browser west of Quebec shows
 * as the day before; the day is always the first 10 characters. Anything else falls back to `new Date()`.
 */
export function parseCalendarDate(value: string): Date {
  const day = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return day ? new Date(+day[1], +day[2] - 1, +day[3]) : new Date(value);
}
